import { createApiActions } from '../../utils/api-state';
import { FeatureFlagDataModel } from '../../models/feature-flag.model';

export const getHubFeatureFlagActions = createApiActions<'hub', FeatureFlagDataModel[]>(
  '[Feature-Flag] Get The Hub Feature Flags'
);
export const getOfferFeatureFlagActions = createApiActions<'offers', FeatureFlagDataModel[]>(
  '[Feature-Flag] Get The Offer Feature Flags'
);
